export interface IEidosGraphicChooserConfig {
  isValid: boolean;
  code: string;
  description: string;
  folder: string;
  filePrefix: string;
  legend: string;
  levels: Array<number>;
  svgTrasform: Array<IEidosGraphicChooserTranform>;
  levelsTitle: {[key: number]: string};
  placePrefix?: string;
  backgroundPrefix?: string;
  textPrefix?: string;
  levelPrefix?: string;
  layerOverSelectors?: Array<string>;
  tooltip?: IEidosGraphicChooserTooltipOptions;
  document?: string;
  version?: number;
}
export interface IEidosGraphicChooserTranform {
  key: string;
  backgroundColor: string;
  foregroundColor: string;
  type: string;
  cssClasses: string;
}
export interface IEidosGraphicChooserTooltipOptions {
  enabled: boolean;
  debounce?: number;
  type?: 'onside' | 'onpointer';
}
export interface IEidosGraphicChooserPlaceInfoTooltip {
  selection: IEidosGraphicChooserSelection;
  info: string;
}
export interface IEidosGraphicChooserSelection {
  level?: number;
  type?: string;
  selection: string;
  stroke?: string;
  fill?: string;
}
export interface IEidosGraphicChooserConnectedSelection {
  selection: string | IEidosGraphicChooserSelection
  connected: string | IEidosGraphicChooserSelection
}
export interface IEidosGraphicChooserFeatures {
  selection: string | IEidosGraphicChooserSelection
  icons: string[]
  color?: string
  cssStyle?: string
  classes: string[]
}
export interface IEidosGraphicChooserRemappedSelection {
  selection: IEidosGraphicChooserSelection
  selectionChange?: IEidosGraphicChooserSelection
  excludeTags?: string[]
  applyStyles?: [{property:string,value:string}]
  addClasses?: string[]
}
export class EidosGraphicChooserMethods {
  public clearSelection = () => { };
  public selectPlace = (_: IEidosGraphicChooserSelection) => { };
  public resetConfig = () => { };
  public show = () => { };
}
